export const sm = '12px';
export const md = '14px';
export const lg = '18px';
export const xl = '24px';
